<template>
  <div class="app-consumptions">
    <dyn-slot>
      <slot name="txtBefore">Verbrauchsanzeige</slot>
    </dyn-slot>
    <ConsumptionList :consumptions="consumptions.consumptionsForUnit">
      <template v-for="slot in possibleChildSlotsFor('Consumptions')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ConsumptionList>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>

import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import ConsumptionList from '../../Consumption/lidl/ConsumptionList.vue'
import transaction from '../../../../../mixins/transaction'
import slotProxy from '../../../../../mixins/slotProxy'

export const stepName = 'view'
export default {
  components: { ConsumptionList },
  data () {
    return {
      consumptions: {
        consumptionsForUnit: []
      }
    }
  },
  name: 'ConsumptionsWithoutTariffsWrapper',
  mixins: [
    transaction('consumptions'),
    slotProxy()
  ],
  apollo: {
    consumptions: function () {
      return wrapQuery(
        gql`query consumptions {
 consumptions {
    consumptionsForUnit {
      consumed
      unit
      type
      expirationDate
      left
      max
   }
 }
}`, this, 'consumptions'
      )
    }
  }
}
</script>
